import {
    animate,
    animation,
    query,
    sequence,
    stagger,
    style
  } from '@angular/animations';

export const SidebarOpenAnimation = animation([
    style({ left: '-{{menuWidth}}' }),
    query('.profile-opt', [style({ transform: 'translateX(-{{menuWidth}})' })], {optional: true}),
    sequence([
      animate('0ms', ),
      query('.profile-opt', [
        stagger(25, [animate('{{animationStyle}}', style({ transform: 'none' }))])
      ], {optional: true})
    ])
  ]);

export const SidebarCloseAnimation = animation([
    ,
    query('.profile-opt', [style({ transform: 'none' })], {optional: true}),
    sequence([
      query('.profile-opt', [
        stagger(-25, [
          animate(
            '{{animationStyle}}',
            style({ transform: 'translateX(-{{menuWidth}})' })
          )
        ])
      ], {optional: true}),
      animate('0ms', style({ left: '-{{menuWidth}}' }))
    ])
  ]);
